import React from 'react';
import CookietractorInformationComponent from 'content/CookietractorInformation';

const CookietractorInformationBlock = () => <CookietractorInformationComponent />;

export default CookietractorInformationBlock;
